module.exports = __webpack_public_path__ + "static/media/16.a9ea029b.jpg";